import React from "react";
import { ShieldCheck, Award, Wrench, Users } from "lucide-react";

export default function About() {
  return (
    <div className="bg-[#040B16] text-white">
      <section className="max-w-7xl mx-auto px-6 py-24 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-6">
          <div className="eyebrow mb-3">About us</div>
          <h1 className="font-display font-extrabold text-5xl sm:text-6xl tracking-tighter leading-none mb-6">Ten years of driving excellence.</h1>
          <p className="text-white/70 leading-relaxed mb-4">
            Global Prime Fleet was founded in 2014 with a single-minded ambition: to redefine what car rental could feel like. From our headquarters in Plano, Texas, we've grown from a handful of executive sedans to a nationwide fleet of 500+ vehicles serving discerning travelers across the United States.
          </p>
          <p className="text-white/70 leading-relaxed">
            We believe transportation should never feel like a compromise. That's why every vehicle we operate is maintained on a strict service program, driven by our chauffeurs when needed, and delivered spotless — every single time.
          </p>
        </div>
        <div className="lg:col-span-6">
          <img src="https://images.pexels.com/photos/18251570/pexels-photo-18251570.jpeg?w=1200" alt="" className="rounded-2xl w-full aspect-[4/5] object-cover border border-white/10" />
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 pb-24 grid md:grid-cols-3 gap-6">
        {[
          { t: "Mission", d: "To deliver premium, reliable and affordable rentals with concierge-level service — every mile, every journey." },
          { t: "Vision", d: "To become North America's most trusted name in luxury and economy mobility, redefining the rental standard." },
          { t: "Values", d: "Precision, hospitality, safety and trust. We treat every guest like a lifelong customer." },
        ].map((c) => (
          <div key={c.t} className="card-marketing p-8">
            <div className="eyebrow mb-2">{c.t}</div>
            <p className="text-white/70 leading-relaxed">{c.d}</p>
          </div>
        ))}
      </section>

      <section className="bg-[#0B1F3A]/40 border-y border-white/5 py-24">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-4 gap-6">
          {[
            { icon: ShieldCheck, t: "Safety First", d: "Full multi-point inspections after every rental." },
            { icon: Award, t: "Award-Winning Service", d: "Consistently rated 4.9★ across 12,000+ reviews." },
            { icon: Wrench, t: "Maintenance Program", d: "OEM-certified technicians, scheduled preventive care." },
            { icon: Users, t: "Experienced Team", d: "Concierges and chauffeurs with 5+ years experience." },
          ].map((c) => (
            <div key={c.t} className="p-6">
              <c.icon className="w-8 h-8 text-[#D4AF37] mb-3" />
              <div className="font-display text-xl font-bold mb-1">{c.t}</div>
              <p className="text-white/60 text-sm leading-relaxed">{c.d}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
